module.exports = __webpack_public_path__ + "img/discount_howto4.61aa1184.jpg";